import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Apple = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.66"
        height="24"
        fill="currentColor"
        viewBox="0 0 20.66 24"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          d="M18.47,16.67v.05s-.02.02-.02.03c-.38,1.19-.97,2.28-1.72,3.28-.34.46-.7.92-1.14,1.3-.61.52-1.31.75-2.11.6-.39-.07-.75-.22-1.1-.38-.91-.42-1.85-.5-2.81-.19-.38.12-.73.29-1.1.43-.46.18-.94.27-1.44.17-.53-.1-.96-.39-1.32-.76-.83-.84-1.52-1.79-2.07-2.83-.73-1.37-1.18-2.83-1.37-4.37-.12-1.01-.1-2.02.14-3.01.32-1.31.96-2.42,2.07-3.21,1.26-.89,2.64-1.17,4.13-.63.39.14.77.29,1.15.44.47.19.93.19,1.39,0,.26-.11.54-.2.8-.31,1.1-.46,2.23-.6,3.39-.29,1.09.29,1.96.89,2.6,1.8-.22.17-.45.34-.65.52-1.81,1.6-2.02,4.32-.46,6.14.45.53,1,.94,1.64,1.2Z"
        />
        <path
          strokeWidth={0}
          d="M14.3,2c.24,1.52-.79,3.82-2.97,4.49-.29.09-.58.13-.88.12-.12,0-.17-.05-.18-.18-.05-.66.11-1.28.4-1.86.68-1.36,1.77-2.21,3.26-2.53.07-.01.13-.03.2-.04h.18Z"
        />
      </svg>
    );
  },
);

export default Apple;
